var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLicensing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "464pt",
    viewBox: "0 0 464 464",
    width: "464pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m88 32v432h320v-432zm0 0",
    fill: "#348fd9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m392 88-56-56h-248v416h304zm0 0",
    fill: "#3086cd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m56 432h320v-360l-72-72h-248zm0 0",
    fill: "#60d1e0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m376 72h-72v-72zm0 0",
    fill: "#9fe4ed"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m376 168-264 264h264zm0 0",
    fill: "#5ac6d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m344 400h-160c-4.417969 0-8-3.582031-8-8v-64c0-4.417969 3.582031-8 8-8h160c4.417969 0 8 3.582031 8 8v64c0 4.417969-3.582031 8-8 8zm-152-16h144v-48h-144zm0 0",
    fill: "#348fd9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m208 352h32v16h-32zm0 0",
    fill: "#348fd9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m256 352h64v16h-64zm0 0",
    fill: "#348fd9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m240 256 47.996094-47.996094 112 112-47.996094 47.996094zm0 0",
    fill: "#e0e0de"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m416 136c-26.507812 0-48 21.492188-48 48v4l-72 76 40 40 76-72h4c26.507812 0 48-21.492188 48-48s-21.492188-48-48-48zm0 0",
    fill: "#95573a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m216.003906 279.996094 24-24 112 112-24 24zm0 0",
    fill: "#ebebe9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m435.664062 140.238281c-33.144531 83.816407-84.929687 123.832031-119.574218 143.851563l19.910156 19.910156 76-72h4c22.609375-.027344 42.136719-15.832031 46.875-37.941406s-6.597656-44.527344-27.210938-53.820313zm0 0",
    fill: "#8f4d2e"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m246.953125 75.199219c2.503906-5.207031 1.445313-11.425781-2.640625-15.511719s-10.304688-5.144531-15.511719-2.640625c-1.921875-5.433594-7.058593-9.070313-12.824219-9.070313-5.765624 0-10.90625 3.636719-12.824218 9.070313-5.203125-2.46875-11.398438-1.394531-15.464844 2.683594s-5.125 10.273437-2.640625 15.46875c-5.433594 1.921875-9.070313 7.058593-9.070313 12.824219 0 5.765624 3.636719 10.90625 9.070313 12.824218-2.46875 5.203125-1.394531 11.398438 2.683594 15.464844s10.273437 5.125 15.46875 2.640625c1.921875 5.433594 7.058593 9.070313 12.824219 9.070313 5.765624 0 10.90625-3.636719 12.824218-9.070313 5.203125 2.46875 11.398438 1.394531 15.464844-2.683594s5.125-10.273437 2.640625-15.46875c5.402344-1.941406 9.003906-7.0625 9.003906-12.800781s-3.601562-10.859375-9.003906-12.800781zm0 0",
    fill: "#ffb531"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m192 136c.023438-32.289062-17.648438-61.992188-46.039062-77.378906-28.386719-15.382813-62.921876-13.972656-89.960938 3.675781v147.40625c27.039062 17.648437 61.574219 19.058594 89.960938 3.675781 28.390624-15.386718 46.0625-45.089844 46.039062-77.378906zm0 0",
    fill: "#5ac6d4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m320 72h56v16h-56zm0 0",
    fill: "#5ac6d4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3fb7c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m144 224h80v16h-80zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 256h96v16h-96zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 192h168v16h-168zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 288h48v16h-48zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 320h64v16h-64zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 352h64v16h-64zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 384h64v16h-64zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 224h32v16h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 288h32v16h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 152h32v16h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208 152h64v16h-64zm0 0"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m176 120c0 48.601562-39.398438 88-88 88s-88-39.398438-88-88 39.398438-88 88-88 88 39.398438 88 88zm0 0",
    fill: "#7eb457"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m56 168c-2.121094 0-4.15625-.84375-5.65625-2.34375l-24-24 11.3125-11.3125 18.34375 18.34375 74.34375-74.34375 11.3125 11.3125-80 80c-1.5 1.5-3.535156 2.34375-5.65625 2.34375zm0 0",
    fill: "#ffb531"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m190.175781 118.128906c-1.1875-5.765625-2.957031-11.394531-5.28125-16.800781-2.6875 6.132813-.429687 13.308594 5.28125 16.800781zm0 0",
    fill: "#f98500"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m184.496094 100.519531c-2.261719-5.121093-5.003906-10.015625-8.191406-14.617187-1.0625 6.195312 2.351562 12.289062 8.191406 14.617187zm0 0",
    fill: "#f98500"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensing);
export default __webpack_public_path__ + "static/media/licensing.c4b285fb2a10e045e27a802d3c4fc0b3.svg";
export { ForwardRef as ReactComponent };